import styled, { css } from 'styled-components';
import {
  text0css,
  text1css,
  text2css,
  text3css,
  text4css,
  text5css,
  text6css,
  text7css,
  text8css,
  text9css,
  // textNormal,
  // textBlack,
  // textBold,
  // textBoldLoose,
} from './css';

export const Text = styled.p`
  color: ${({ color = 'inherit' }) => `var(--color-${color})`};
  text-align: ${({ align = 'inherit' }) => align};
  ${({ lineHeight }) =>
    lineHeight
      ? css`
          && {
            line-height: ${lineHeight};
          }
        `
      : ''};
`;

// @todo remove compoent and use css variable instead
/* 12px */
export const Text0 = styled(Text)`
  ${text0css};
`;

/* 12px */
export const Text1 = styled(Text)`
  ${text1css};
`;

/* 14px */
export const Text2 = styled(Text)`
  ${text2css};
`;

/* 16px */
export const Text3 = styled(Text)`
  ${text3css};
`;

/* 18px */
export const Text4 = styled(Text)`
  ${text4css};
`;

/* 20px */
export const Text5 = styled(Text)`
  ${text5css};
`;

/* 24px */
export const Text6 = styled(Text)`
  ${text6css};
`;

/* 30px */
export const Text7 = styled(Text)`
  ${text7css};
`;

/* 36px */
export const Text8 = styled(Text)`
  ${text8css};
`;

/* 48px */
export const Text9 = styled(Text)`
  ${text9css};
`;
